import { TaskType } from './types/enumValues';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Empty: any;
  FormData: any;
};

export type Annexes = {
  __typename?: 'Annexes';
  amount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  index?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  quasi?: Maybe<Scalars['Boolean']>;
  unit?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

export type Case = {
  __typename?: 'Case';
  advice?: Maybe<Scalars['String']>;
  assignedValuator?: Maybe<Valuator>;
  caseDocuments?: Maybe<Array<Maybe<Scalars['String']>>>;
  caseProperty: CaseProperty;
  caseRef: Scalars['String'];
  classification: Classification;
  clientComments?: Maybe<Array<Maybe<ClientComment>>>;
  currentCaseStatus?: Maybe<CurrentCaseStatus>;
  customerInputs?: Maybe<CustomerInputs>;
  flow?: Maybe<Flow>;
  municipality?: Maybe<Scalars['String']>;
  objectionGoal?: Maybe<Scalars['String']>;
  partnerUrl?: Maybe<Scalars['String']>;
  recentlySold?: Maybe<Scalars['Boolean']>;
  statusHistory?: Maybe<Array<Maybe<StatusHistory>>>;
  tasks?: Maybe<Array<Maybe<Task>>>;
  taxYear: Scalars['Int'];
  userFlow?: Maybe<Scalars['String']>;
  wozData?: Maybe<WozData>;
};

export type CaseDocument = {
  __typename?: 'CaseDocument';
  uuid?: Maybe<Scalars['String']>;
};

export type CaseProperty = {
  __typename?: 'CaseProperty';
  appearanceIndication?: Maybe<Scalars['String']>;
  atticArea?: Maybe<Scalars['Int']>;
  bagId?: Maybe<Scalars['String']>;
  bathroomAge?: Maybe<Scalars['String']>;
  bathroomMaintenanceIndication?: Maybe<Scalars['String']>;
  bayWindowArea?: Maybe<Scalars['Int']>;
  builtInKitchen?: Maybe<Scalars['Boolean']>;
  city: Scalars['String'];
  constructionYear?: Maybe<Scalars['Int']>;
  doubleGlass?: Maybe<Scalars['String']>;
  efficiencyIndication?: Maybe<Scalars['String']>;
  floorInsulation?: Maybe<Scalars['String']>;
  floorLevel?: Maybe<Scalars['Int']>;
  foundationSubsidence?: Maybe<Scalars['Boolean']>;
  garageArea?: Maybe<Scalars['Int']>;
  heatingAge?: Maybe<Scalars['String']>;
  heatingState?: Maybe<Scalars['String']>;
  houseNumber: Scalars['Int'];
  houseNumberAddition?: Maybe<Scalars['String']>;
  insideCracks?: Maybe<Scalars['String']>;
  insideMaintenanceIndication?: Maybe<Scalars['String']>;
  insidePaintwork?: Maybe<Scalars['String']>;
  kitchenAge?: Maybe<Scalars['String']>;
  kitchenMaintenanceIndication?: Maybe<Scalars['String']>;
  landLeaseFee?: Maybe<Scalars['Int']>;
  landOwnership?: Maybe<Scalars['String']>;
  latitude: Scalars['Int'];
  leadPipes?: Maybe<Scalars['Boolean']>;
  leakage?: Maybe<Scalars['Boolean']>;
  livingArea?: Maybe<Scalars['Int']>;
  locationIndication?: Maybe<Scalars['String']>;
  longitude: Scalars['Int'];
  luxuryIndication?: Maybe<Scalars['Int']>;
  maintenanceIndication?: Maybe<Scalars['Int']>;
  outsideCracks?: Maybe<Scalars['String']>;
  outsideMaintenanceIndication?: Maybe<Scalars['String']>;
  outsidePaintwork?: Maybe<Scalars['String']>;
  parkingArea?: Maybe<Scalars['Int']>;
  plotArea?: Maybe<Scalars['Int']>;
  postcode?: Maybe<Scalars['String']>;
  propertyType?: Maybe<Scalars['String']>;
  purchaseMonth?: Maybe<Scalars['Int']>;
  purchasePrice?: Maybe<Scalars['Int']>;
  purchaseYear?: Maybe<Scalars['Int']>;
  renovated?: Maybe<Scalars['Boolean']>;
  renovationComplete?: Maybe<Scalars['String']>;
  renovationCosts?: Maybe<Scalars['Int']>;
  roofInsulation?: Maybe<Scalars['String']>;
  servicesIndication?: Maybe<Scalars['Int']>;
  solarPanels?: Maybe<Scalars['Boolean']>;
  street: Scalars['String'];
  structureArea?: Maybe<Scalars['Int']>;
  underfloorHeating?: Maybe<Scalars['Boolean']>;
  wallInsulation?: Maybe<Scalars['String']>;
  warmWater?: Maybe<Scalars['String']>;
  windowFramesMaterial?: Maybe<Scalars['String']>;
  windowFramesRot?: Maybe<Scalars['String']>;
  wozDecisionDate?: Maybe<Scalars['String']>;
};

export type CasePropertyInput = {
  appearanceIndication?: InputMaybe<Scalars['String']>;
  bagId?: InputMaybe<Scalars['String']>;
  bathroomAge?: InputMaybe<Scalars['String']>;
  bathroomMaintenanceIndication?: InputMaybe<Scalars['String']>;
  builtInKitchen?: InputMaybe<Scalars['Boolean']>;
  city?: InputMaybe<Scalars['String']>;
  clientComments?: InputMaybe<ClientCommentsInput>;
  constructionYear?: InputMaybe<Scalars['Int']>;
  doubleGlass?: InputMaybe<Scalars['String']>;
  efficiencyIndication?: InputMaybe<Scalars['String']>;
  floorInsulation?: InputMaybe<Scalars['String']>;
  floorLevel?: InputMaybe<Scalars['Int']>;
  foundationSubsidence?: InputMaybe<Scalars['Boolean']>;
  heatingAge?: InputMaybe<Scalars['String']>;
  heatingState?: InputMaybe<Scalars['String']>;
  houseNumber?: InputMaybe<Scalars['Int']>;
  insideCracks?: InputMaybe<Scalars['String']>;
  insideMaintenanceIndication?: InputMaybe<Scalars['String']>;
  insidePaintwork?: InputMaybe<Scalars['String']>;
  kitchenAge?: InputMaybe<Scalars['String']>;
  kitchenMaintenanceIndication?: InputMaybe<Scalars['String']>;
  landLeaseFee?: InputMaybe<Scalars['Int']>;
  landOwnership?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Int']>;
  leadPipes?: InputMaybe<Scalars['Boolean']>;
  leakage?: InputMaybe<Scalars['Boolean']>;
  livingArea?: InputMaybe<Scalars['Int']>;
  locationIndication?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['Int']>;
  luxuryIndication?: InputMaybe<Scalars['Int']>;
  maintenanceIndication?: InputMaybe<Scalars['Int']>;
  outsideCracks?: InputMaybe<Scalars['String']>;
  outsideMaintenanceIndication?: InputMaybe<Scalars['String']>;
  outsidePaintwork?: InputMaybe<Scalars['String']>;
  plotArea?: InputMaybe<Scalars['Int']>;
  postcode?: InputMaybe<Scalars['String']>;
  propertyType?: InputMaybe<Scalars['String']>;
  purchaseMonth?: InputMaybe<Scalars['Int']>;
  purchasePrice?: InputMaybe<Scalars['Int']>;
  purchaseYear?: InputMaybe<Scalars['Int']>;
  renovated?: InputMaybe<Scalars['Boolean']>;
  renovationComplete?: InputMaybe<Scalars['String']>;
  renovationCosts?: InputMaybe<Scalars['Int']>;
  roofInsulation?: InputMaybe<Scalars['String']>;
  servicesIndication?: InputMaybe<Scalars['Int']>;
  solarPanels?: InputMaybe<Scalars['Boolean']>;
  street?: InputMaybe<Scalars['String']>;
  underfloorHeating?: InputMaybe<Scalars['Boolean']>;
  wallInsulation?: InputMaybe<Scalars['String']>;
  warmWater?: InputMaybe<Scalars['String']>;
  windowFramesMaterial?: InputMaybe<Scalars['String']>;
  windowFramesRot?: InputMaybe<Scalars['String']>;
};

export type Cases = {
  __typename?: 'Cases';
  cases?: Maybe<Array<Case>>;
};

export type ChangeDetailsInput = {
  dateOfBirth?: InputMaybe<Scalars['String']>;
  emailPreferences?: InputMaybe<EmailPreferencesInput>;
  firstName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  salutation?: InputMaybe<Scalars['String']>;
  surname?: InputMaybe<Scalars['String']>;
};

export type ChangeEmailInput = {
  email?: InputMaybe<Scalars['String']>;
};

export type ChangePasswordInput = {
  newPassword?: InputMaybe<Scalars['String']>;
  oldPassword?: InputMaybe<Scalars['String']>;
};

export enum Classification {
  Green = 'green',
  Orange = 'orange',
  Red = 'red'
}

export type ClientComment = {
  __typename?: 'ClientComment';
  createdAt?: Maybe<Scalars['String']>;
  sectionType?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  uploads?: Maybe<Array<Maybe<Upload>>>;
};

export type ClientCommentInput = {
  text?: InputMaybe<Scalars['String']>;
  uploads?: InputMaybe<Array<InputMaybe<UploadInput>>>;
};

export type ClientCommentsInput = {
  areaLocation?: InputMaybe<ClientCommentInput>;
  kitchenBathroom?: InputMaybe<ClientCommentInput>;
  maintenance?: InputMaybe<ClientCommentInput>;
  objectType?: InputMaybe<ClientCommentInput>;
  other?: InputMaybe<ClientCommentInput>;
  quality?: InputMaybe<ClientCommentInput>;
};

export type CurrentCaseStatus = {
  __typename?: 'CurrentCaseStatus';
  expired?: Maybe<Scalars['Boolean']>;
  final?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
};

export type CustomerInputs = {
  __typename?: 'CustomerInputs';
  apartmentType?: Maybe<Scalars['String']>;
  bathroomAge?: Maybe<Scalars['String']>;
  kitchenAge?: Maybe<Scalars['String']>;
  livingArea?: Maybe<Scalars['Int']>;
  maintenanceIndication?: Maybe<Scalars['String']>;
  propertyType?: Maybe<Scalars['String']>;
  recentlySold?: Maybe<Scalars['Int']>;
  relationshipToProperty?: Maybe<Scalars['String']>;
  renovated?: Maybe<Scalars['Boolean']>;
  sustainabilityIndication?: Maybe<Scalars['String']>;
  userFlow?: Maybe<Scalars['String']>;
  wozValue?: Maybe<Scalars['Int']>;
};

export type DownloadDocumentInput = {
  query?: InputMaybe<Scalars['String']>;
};

export type EmailPreferences = {
  __typename?: 'EmailPreferences';
  otherMarketing?: Maybe<Scalars['Boolean']>;
  wozAdvice?: Maybe<Scalars['Boolean']>;
  wozNews?: Maybe<Scalars['Boolean']>;
};

export type EmailPreferencesInput = {
  otherMarketing?: InputMaybe<Scalars['Boolean']>;
  wozAdvice?: InputMaybe<Scalars['Boolean']>;
  wozNews?: InputMaybe<Scalars['Boolean']>;
};

export type EmailTokenLoginInput = {
  emailToken?: InputMaybe<Scalars['String']>;
};

export type EmptyResponse = {
  __typename?: 'EmptyResponse';
  NoResponse?: Maybe<Scalars['Empty']>;
};

export type FileId = {
  __typename?: 'FileId';
  file?: Maybe<Scalars['String']>;
};

export type Flow = {
  __typename?: 'Flow';
  flowSteps?: Maybe<Array<Maybe<FlowStep>>>;
  flowType?: Maybe<Scalars['String']>;
};

export type FlowStep = {
  __typename?: 'FlowStep';
  flowStepStatus?: Maybe<Scalars['String']>;
  flowStepType?: Maybe<Scalars['String']>;
};

export type ForgotPasswordInput = {
  email?: InputMaybe<Scalars['String']>;
};

export type LoginAvailable = {
  __typename?: 'LoginAvailable';
  loginAvailable: Scalars['Boolean'];
};

export type LoginAvailableInput = {
  email: Scalars['String'];
};

export type LoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type MessageValuatorInput = {
  message?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  postTask?: Maybe<EmptyResponse>;
  postTaskUpload?: Maybe<FileId>;
};


export type MutationPostTaskArgs = {
  caseRef?: InputMaybe<Scalars['String']>;
  input?: InputMaybe<PostTaskInput>;
  taskId?: InputMaybe<Scalars['String']>;
};


export type MutationPostTaskUploadArgs = {
  caseRef?: InputMaybe<Scalars['String']>;
  input?: InputMaybe<Scalars['FormData']>;
  section?: InputMaybe<Scalars['String']>;
  taskId?: InputMaybe<Scalars['String']>;
};

export type PoaProps = {
  fileData?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  kind?: InputMaybe<Scalars['String']>;
  signee?: InputMaybe<Signee>;
};

export type PostCaseInput = {
  directMail?: InputMaybe<Scalars['Boolean']>;
  fromEmail?: InputMaybe<Scalars['Boolean']>;
  userFlow?: InputMaybe<Scalars['String']>;
  wozCheck?: InputMaybe<WozCheck>;
};

export type PostTaskInput = {
  apartmentType?: InputMaybe<Scalars['String']>;
  clientComment?: InputMaybe<ClientCommentInput>;
  decision?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  livingArea?: InputMaybe<Scalars['String']>;
  plotArea?: InputMaybe<Scalars['String']>;
  purchaseDate?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export type Profile = {
  __typename?: 'Profile';
  dateOfBirth?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailPreferences?: Maybe<EmailPreferences>;
  firstName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  salutation?: Maybe<Scalars['String']>;
  surname?: Maybe<Scalars['String']>;
};

export type ProfileInput = {
  email?: InputMaybe<Scalars['String']>;
  emailPreferences?: InputMaybe<EmailPreferencesInput>;
  firstName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  salutation?: InputMaybe<Scalars['String']>;
  surname?: InputMaybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  bindCase?: Maybe<EmptyResponse>;
  cases?: Maybe<Cases>;
  changeCaseDetails?: Maybe<CaseProperty>;
  changeDetails?: Maybe<Profile>;
  changeEmail?: Maybe<User>;
  changePassword?: Maybe<EmptyResponse>;
  deleteTaskUpload?: Maybe<EmptyResponse>;
  downloadDocument?: Maybe<Upload>;
  emailTokenLogin?: Maybe<User>;
  forgotPassword?: Maybe<EmptyResponse>;
  getUserData?: Maybe<Profile>;
  login?: Maybe<User>;
  loginAvailable?: Maybe<LoginAvailable>;
  messageValuator?: Maybe<EmptyResponse>;
  postCase?: Maybe<Case>;
  register?: Maybe<User>;
  resetPassword?: Maybe<User>;
  socialLogin?: Maybe<User>;
  submitPoa?: Maybe<EmptyResponse>;
  submitPoaOrangeCase?: Maybe<EmptyResponse>;
};


export type QueryBindCaseArgs = {
  caseRef?: InputMaybe<Scalars['String']>;
};


export type QueryChangeCaseDetailsArgs = {
  caseRef?: InputMaybe<Scalars['String']>;
  input?: InputMaybe<CasePropertyInput>;
};


export type QueryChangeDetailsArgs = {
  input?: InputMaybe<ChangeDetailsInput>;
};


export type QueryChangeEmailArgs = {
  input?: InputMaybe<ChangeEmailInput>;
};


export type QueryChangePasswordArgs = {
  input?: InputMaybe<ChangePasswordInput>;
};


export type QueryDeleteTaskUploadArgs = {
  caseRef?: InputMaybe<Scalars['String']>;
  documentId?: InputMaybe<Scalars['String']>;
  taskId?: InputMaybe<Scalars['String']>;
};


export type QueryDownloadDocumentArgs = {
  caseRef?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryEmailTokenLoginArgs = {
  input: EmailTokenLoginInput;
};


export type QueryForgotPasswordArgs = {
  input?: InputMaybe<ForgotPasswordInput>;
};


export type QueryLoginArgs = {
  input: LoginInput;
};


export type QueryLoginAvailableArgs = {
  input: LoginAvailableInput;
};


export type QueryMessageValuatorArgs = {
  caseRef?: InputMaybe<Scalars['String']>;
  input?: InputMaybe<MessageValuatorInput>;
};


export type QueryPostCaseArgs = {
  caseRef?: InputMaybe<Scalars['String']>;
  input?: InputMaybe<PostCaseInput>;
};


export type QueryRegisterArgs = {
  input: RegisterInput;
};


export type QueryResetPasswordArgs = {
  input?: InputMaybe<ResetPasswordInput>;
};


export type QuerySocialLoginArgs = {
  input: SocialLoginInput;
};


export type QuerySubmitPoaArgs = {
  caseRef?: InputMaybe<Scalars['String']>;
  input?: InputMaybe<SubmitPoaInput>;
};


export type QuerySubmitPoaOrangeCaseArgs = {
  caseRef?: InputMaybe<Scalars['String']>;
  input?: InputMaybe<SubmitPoaInput>;
};

export type RegisterInput = {
  email?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  profile?: InputMaybe<ProfileInput>;
};

export type ResetPasswordInput = {
  password?: InputMaybe<Scalars['String']>;
  password_confirm?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

export type Savings = {
  __typename?: 'Savings';
  avg?: Maybe<Scalars['Int']>;
  incomeTax?: Maybe<SavingsBreakdown>;
  max?: Maybe<Scalars['Int']>;
  min?: Maybe<Scalars['Int']>;
  realEstateTax?: Maybe<SavingsBreakdown>;
  status?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  waterTax?: Maybe<SavingsBreakdown>;
};

export type SavingsBreakdown = {
  __typename?: 'SavingsBreakdown';
  avg?: Maybe<Scalars['Int']>;
  max?: Maybe<Scalars['Int']>;
  min?: Maybe<Scalars['Int']>;
};

export type Signee = {
  dateOfBirth?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  surname?: InputMaybe<Scalars['String']>;
};

export type SocialLoginInput = {
  facebookToken?: InputMaybe<Scalars['String']>;
  googleToken?: InputMaybe<Scalars['String']>;
  platform: SocialPlatform;
};

export enum SocialPlatform {
  Empty = 'Empty'
}

export enum SocialPlatformToken {
  Empty = 'Empty'
}

export type StatusHistory = {
  __typename?: 'StatusHistory';
  caseId?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type SubmitPoaInput = {
  poa?: InputMaybe<PoaProps>;
};

export type Task = {
  __typename?: 'Task';
  data?: Maybe<TaskData>;
  deadline?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  statusHistory?: Maybe<Array<Maybe<StatusHistory>>>;
  taskId: Scalars['String'];
  type?: Maybe<TaskType>;
  uploads?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type TaskData = {
  __typename?: 'TaskData';
  annexes?: Maybe<Array<Maybe<Annexes>>>;
  apartmentType?: Maybe<Scalars['String']>;
  clientComment?: Maybe<ClientComment>;
  constructionYear?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['String']>;
  decision?: Maybe<Scalars['String']>;
  document?: Maybe<Upload>;
  livingArea?: Maybe<Scalars['Int']>;
  maintenanceIndication?: Maybe<Scalars['String']>;
  objectionOutcome?: Maybe<Scalars['String']>;
  paymentRequestId?: Maybe<Scalars['String']>;
  plotArea?: Maybe<Scalars['Int']>;
  purchasePrice?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['String']>;
  uploads?: Maybe<Array<Maybe<Upload>>>;
  volume?: Maybe<Scalars['Int']>;
};

export { TaskType };

export type Upload = {
  __typename?: 'Upload';
  by?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  fileData?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

export type UploadInput = {
  by?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
  fileData?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  idToken?: Maybe<Scalars['String']>;
  lastLogin?: Maybe<Scalars['String']>;
  profile: Profile;
  trackingId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Float']>;
};

export type Valuator = {
  __typename?: 'Valuator';
  avatar?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  salutation?: Maybe<Scalars['String']>;
  surname?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type WozCheck = {
  bathroomAge?: InputMaybe<Scalars['String']>;
  bathroomMaintenanceIndication?: InputMaybe<Scalars['String']>;
  insideMaintenanceIndication?: InputMaybe<Scalars['String']>;
  kitchenAge?: InputMaybe<Scalars['String']>;
  kitchenMaintenanceIndication?: InputMaybe<Scalars['String']>;
  landLeaseFee?: InputMaybe<Scalars['Int']>;
  landOwnership?: InputMaybe<Scalars['String']>;
  livingArea?: InputMaybe<Scalars['Int']>;
  locationIndication?: InputMaybe<Scalars['String']>;
  luxuryIndication?: InputMaybe<Scalars['String']>;
  maintenanceIndication?: InputMaybe<Scalars['String']>;
  outsideMaintenanceIndication?: InputMaybe<Scalars['String']>;
  plotArea?: InputMaybe<Scalars['Int']>;
  recentlySold?: InputMaybe<Scalars['Boolean']>;
  relationshipToProperty?: InputMaybe<Scalars['String']>;
  renovated?: InputMaybe<Scalars['Boolean']>;
  renovationCompletion?: InputMaybe<Scalars['Int']>;
  renovationCosts?: InputMaybe<Scalars['Int']>;
  sustainabilityIndication?: InputMaybe<Scalars['String']>;
};

export type WozData = {
  __typename?: 'WozData';
  ewozValue?: Maybe<Scalars['Int']>;
  finalSavings?: Maybe<Savings>;
  finalWoz?: Maybe<Scalars['Int']>;
  objectionWoz?: Maybe<Scalars['Int']>;
  savings?: Maybe<Savings>;
  wozDecisionDate?: Maybe<Scalars['String']>;
  wozValue?: Maybe<Scalars['Int']>;
};

export type PostTaskMutationVariables = Exact<{
  caseRef?: InputMaybe<Scalars['String']>;
  taskId?: InputMaybe<Scalars['String']>;
  input?: InputMaybe<PostTaskInput>;
}>;


export type PostTaskMutation = { __typename?: 'Mutation', postTask?: { __typename?: 'EmptyResponse', NoResponse?: any | null } | null };

export type PostTaskUploadMutationVariables = Exact<{
  caseRef?: InputMaybe<Scalars['String']>;
  taskId?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Scalars['String']>;
  input?: InputMaybe<Scalars['FormData']>;
}>;


export type PostTaskUploadMutation = { __typename?: 'Mutation', postTaskUpload?: { __typename?: 'FileId', file?: string | null } | null };

export type BindCaseQueryVariables = Exact<{
  caseRef?: InputMaybe<Scalars['String']>;
}>;


export type BindCaseQuery = { __typename?: 'Query', bindCase?: { __typename?: 'EmptyResponse', NoResponse?: any | null } | null };

export type CasesQueryVariables = Exact<{ [key: string]: never; }>;


export type CasesQuery = { __typename?: 'Query', cases?: { __typename?: 'Cases', cases?: Array<{ __typename?: 'Case', caseRef: string, advice?: string | null, caseDocuments?: Array<string | null> | null, classification: Classification, municipality?: string | null, objectionGoal?: string | null, recentlySold?: boolean | null, taxYear: number, userFlow?: string | null, partnerUrl?: string | null, assignedValuator?: { __typename?: 'Valuator', email?: string | null, firstName?: string | null, salutation?: string | null, surname?: string | null, phoneNumber?: string | null } | null, flow?: { __typename?: 'Flow', flowType?: string | null, flowSteps?: Array<{ __typename?: 'FlowStep', flowStepStatus?: string | null, flowStepType?: string | null } | null> | null } | null, clientComments?: Array<{ __typename?: 'ClientComment', sectionType?: string | null, text?: string | null, updatedAt?: string | null, uploads?: Array<{ __typename?: 'Upload', fileType?: string | null, uuid?: string | null, fileName?: string | null } | null> | null } | null> | null, caseProperty: { __typename?: 'CaseProperty', floorLevel?: number | null, bayWindowArea?: number | null, garageArea?: number | null, parkingArea?: number | null, wozDecisionDate?: string | null, structureArea?: number | null, atticArea?: number | null, kitchenAge?: string | null, heatingState?: string | null, heatingAge?: string | null, warmWater?: string | null, leadPipes?: boolean | null, solarPanels?: boolean | null, underfloorHeating?: boolean | null, floorInsulation?: string | null, roofInsulation?: string | null, wallInsulation?: string | null, doubleGlass?: string | null, leakage?: boolean | null, insidePaintwork?: string | null, outsidePaintwork?: string | null, windowFramesMaterial?: string | null, windowFramesRot?: string | null, insideCracks?: string | null, outsideCracks?: string | null, foundationSubsidence?: boolean | null, kitchenMaintenanceIndication?: string | null, bathroomAge?: string | null, bathroomMaintenanceIndication?: string | null, builtInKitchen?: boolean | null, bagId?: string | null, city: string, outsideMaintenanceIndication?: string | null, insideMaintenanceIndication?: string | null, constructionYear?: number | null, houseNumber: number, houseNumberAddition?: string | null, latitude: number, livingArea?: number | null, locationIndication?: string | null, longitude: number, luxuryIndication?: number | null, maintenanceIndication?: number | null, plotArea?: number | null, postcode?: string | null, propertyType?: string | null, purchaseMonth?: number | null, purchasePrice?: number | null, purchaseYear?: number | null, servicesIndication?: number | null, street: string }, currentCaseStatus?: { __typename?: 'CurrentCaseStatus', expired?: boolean | null, final?: boolean | null, status?: string | null } | null, customerInputs?: { __typename?: 'CustomerInputs', bathroomAge?: string | null, kitchenAge?: string | null, livingArea?: number | null, maintenanceIndication?: string | null, propertyType?: string | null, recentlySold?: number | null, relationshipToProperty?: string | null, sustainabilityIndication?: string | null, renovated?: boolean | null, userFlow?: string | null, wozValue?: number | null } | null, statusHistory?: Array<{ __typename?: 'StatusHistory', caseId?: number | null, status?: string | null, updatedAt?: string | null } | null> | null, tasks?: Array<{ __typename?: 'Task', taskId: string, uploads?: Array<string | null> | null, deadline?: string | null, status?: string | null, type?: TaskType | null, data?: { __typename?: 'TaskData', paymentRequestId?: string | null, objectionOutcome?: string | null, livingArea?: number | null, plotArea?: number | null, document?: { __typename?: 'Upload', path?: string | null, id?: string | null, type?: string | null, createdAt?: string | null, fileData?: string | null, fileName?: string | null, fileType?: string | null } | null, annexes?: Array<{ __typename?: 'Annexes', id?: number | null, name?: string | null, value?: number | null, amount?: number | null, unit?: string | null, quasi?: boolean | null, index?: number | null } | null> | null, clientComment?: { __typename?: 'ClientComment', text?: string | null, uploads?: Array<{ __typename?: 'Upload', fileData?: string | null, fileName?: string | null, fileType?: string | null, id?: string | null } | null> | null } | null } | null, statusHistory?: Array<{ __typename?: 'StatusHistory', caseId?: number | null, status?: string | null, updatedAt?: string | null } | null> | null } | null> | null, wozData?: { __typename?: 'WozData', objectionWoz?: number | null, ewozValue?: number | null, wozValue?: number | null, finalWoz?: number | null, wozDecisionDate?: string | null, savings?: { __typename?: 'Savings', status?: string | null, min?: number | null, max?: number | null, avg?: number | null, waterTax?: { __typename?: 'SavingsBreakdown', avg?: number | null, max?: number | null, min?: number | null } | null, incomeTax?: { __typename?: 'SavingsBreakdown', avg?: number | null, max?: number | null, min?: number | null } | null, realEstateTax?: { __typename?: 'SavingsBreakdown', avg?: number | null, max?: number | null, min?: number | null } | null } | null, finalSavings?: { __typename?: 'Savings', status?: string | null, min?: number | null, max?: number | null, avg?: number | null, waterTax?: { __typename?: 'SavingsBreakdown', avg?: number | null, max?: number | null, min?: number | null } | null, incomeTax?: { __typename?: 'SavingsBreakdown', avg?: number | null, max?: number | null, min?: number | null } | null, realEstateTax?: { __typename?: 'SavingsBreakdown', avg?: number | null, max?: number | null, min?: number | null } | null } | null } | null }> | null } | null };

export type ChangeCaseDetailsQueryVariables = Exact<{
  caseRef?: InputMaybe<Scalars['String']>;
  input?: InputMaybe<CasePropertyInput>;
}>;


export type ChangeCaseDetailsQuery = { __typename?: 'Query', changeCaseDetails?: { __typename?: 'CaseProperty', landOwnership?: string | null, floorInsulation?: string | null, landLeaseFee?: number | null, builtInKitchen?: boolean | null, bagId?: string | null, city: string, renovated?: boolean | null, windowFramesRot?: string | null, roofInsulation?: string | null, efficiencyIndication?: string | null, warmWater?: string | null, floorLevel?: number | null, kitchenMaintenanceIndication?: string | null, bathroomMaintenanceIndication?: string | null, renovationCosts?: number | null, foundationSubsidence?: boolean | null, outsideMaintenanceIndication?: string | null, insideMaintenanceIndication?: string | null, heatingState?: string | null, kitchenAge?: string | null, renovationComplete?: string | null, leadPipes?: boolean | null, leakage?: boolean | null, wallInsulation?: string | null, solarPanels?: boolean | null, underfloorHeating?: boolean | null, outsideCracks?: string | null, appearanceIndication?: string | null, constructionYear?: number | null, houseNumber: number, insideCracks?: string | null, doubleGlass?: string | null, insidePaintwork?: string | null, latitude: number, livingArea?: number | null, locationIndication?: string | null, longitude: number, windowFramesMaterial?: string | null, outsidePaintwork?: string | null, luxuryIndication?: number | null, maintenanceIndication?: number | null, plotArea?: number | null, postcode?: string | null, propertyType?: string | null, purchaseMonth?: number | null, purchasePrice?: number | null, purchaseYear?: number | null, servicesIndication?: number | null, street: string, heatingAge?: string | null, bathroomAge?: string | null } | null };

export type ChangeDetailsQueryVariables = Exact<{
  input: ChangeDetailsInput;
}>;


export type ChangeDetailsQuery = { __typename?: 'Query', changeDetails?: { __typename?: 'Profile', surname?: string | null, email?: string | null, salutation?: string | null, firstName?: string | null, phoneNumber?: string | null, dateOfBirth?: string | null, emailPreferences?: { __typename?: 'EmailPreferences', wozAdvice?: boolean | null, wozNews?: boolean | null, otherMarketing?: boolean | null } | null } | null };

export type ChangeEmailQueryVariables = Exact<{
  input: ChangeEmailInput;
}>;


export type ChangeEmailQuery = { __typename?: 'Query', changeEmail?: { __typename?: 'User', profile: { __typename?: 'Profile', surname?: string | null, email?: string | null, salutation?: string | null, firstName?: string | null, phoneNumber?: string | null } } | null };

export type ChangePasswordQueryVariables = Exact<{
  input: ChangePasswordInput;
}>;


export type ChangePasswordQuery = { __typename?: 'Query', changePassword?: { __typename?: 'EmptyResponse', NoResponse?: any | null } | null };

export type DeleteTaskUploadQueryVariables = Exact<{
  caseRef?: InputMaybe<Scalars['String']>;
  taskId?: InputMaybe<Scalars['String']>;
  documentId?: InputMaybe<Scalars['String']>;
}>;


export type DeleteTaskUploadQuery = { __typename?: 'Query', deleteTaskUpload?: { __typename?: 'EmptyResponse', NoResponse?: any | null } | null };

export type DownloadDocumentQueryVariables = Exact<{
  caseRef?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type DownloadDocumentQuery = { __typename?: 'Query', downloadDocument?: { __typename?: 'Upload', fileName?: string | null, fileType?: string | null, fileData?: string | null } | null };

export type ForgotPasswordQueryVariables = Exact<{
  input: ForgotPasswordInput;
}>;


export type ForgotPasswordQuery = { __typename?: 'Query', forgotPassword?: { __typename?: 'EmptyResponse', NoResponse?: any | null } | null };

export type GetUserDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserDataQuery = { __typename?: 'Query', getUserData?: { __typename?: 'Profile', email?: string | null, firstName?: string | null, salutation?: string | null, surname?: string | null, phoneNumber?: string | null, dateOfBirth?: string | null, emailPreferences?: { __typename?: 'EmailPreferences', wozAdvice?: boolean | null, wozNews?: boolean | null, otherMarketing?: boolean | null } | null } | null };

export type LoginQueryVariables = Exact<{
  input: LoginInput;
}>;


export type LoginQuery = { __typename?: 'Query', login?: { __typename?: 'User', idToken?: string | null, profile: { __typename?: 'Profile', surname?: string | null, email?: string | null, salutation?: string | null, firstName?: string | null, phoneNumber?: string | null } } | null };

export type SocialLoginQueryVariables = Exact<{
  input: SocialLoginInput;
}>;


export type SocialLoginQuery = { __typename?: 'Query', socialLogin?: { __typename?: 'User', idToken?: string | null, profile: { __typename?: 'Profile', surname?: string | null, email?: string | null, salutation?: string | null, firstName?: string | null, phoneNumber?: string | null } } | null };

export type EmailTokenLoginQueryVariables = Exact<{
  input: EmailTokenLoginInput;
}>;


export type EmailTokenLoginQuery = { __typename?: 'Query', emailTokenLogin?: { __typename?: 'User', idToken?: string | null, profile: { __typename?: 'Profile', surname?: string | null, email?: string | null, salutation?: string | null, firstName?: string | null, phoneNumber?: string | null } } | null };

export type LoginAvailableQueryVariables = Exact<{
  input: LoginAvailableInput;
}>;


export type LoginAvailableQuery = { __typename?: 'Query', loginAvailable?: { __typename?: 'LoginAvailable', loginAvailable: boolean } | null };

export type MessageValuatorQueryVariables = Exact<{
  caseRef?: InputMaybe<Scalars['String']>;
  input: MessageValuatorInput;
}>;


export type MessageValuatorQuery = { __typename?: 'Query', messageValuator?: { __typename?: 'EmptyResponse', NoResponse?: any | null } | null };

export type PostCaseQueryVariables = Exact<{
  caseRef?: InputMaybe<Scalars['String']>;
  input: PostCaseInput;
}>;


export type PostCaseQuery = { __typename?: 'Query', postCase?: { __typename?: 'Case', caseProperty: { __typename?: 'CaseProperty', landOwnership?: string | null } } | null };

export type RegisterQueryVariables = Exact<{
  input: RegisterInput;
}>;


export type RegisterQuery = { __typename?: 'Query', register?: { __typename?: 'User', idToken?: string | null, profile: { __typename?: 'Profile', surname?: string | null, email?: string | null, salutation?: string | null, firstName?: string | null, phoneNumber?: string | null } } | null };

export type ResetPasswordQueryVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetPasswordQuery = { __typename?: 'Query', resetPassword?: { __typename?: 'User', idToken?: string | null, profile: { __typename?: 'Profile', surname?: string | null, email?: string | null, salutation?: string | null, firstName?: string | null, phoneNumber?: string | null } } | null };

export type SubmitPoaQueryVariables = Exact<{
  caseRef?: InputMaybe<Scalars['String']>;
  input?: InputMaybe<SubmitPoaInput>;
}>;


export type SubmitPoaQuery = { __typename?: 'Query', submitPoa?: { __typename?: 'EmptyResponse', NoResponse?: any | null } | null };

export type SubmitPoaOrangeCaseQueryVariables = Exact<{
  caseRef?: InputMaybe<Scalars['String']>;
  input?: InputMaybe<SubmitPoaInput>;
}>;


export type SubmitPoaOrangeCaseQuery = { __typename?: 'Query', submitPoaOrangeCase?: { __typename?: 'EmptyResponse', NoResponse?: any | null } | null };


export const PostTaskDocument = gql`
    mutation postTask($caseRef: String, $taskId: String, $input: PostTaskInput) {
  postTask(caseRef: $caseRef, taskId: $taskId, input: $input) @rest(path: "/api/v2/objections/{args.caseRef}/task/{args.taskId}", method: "POST", bodySerializer: "kebabizeObject") {
    NoResponse
  }
}
    `;
export type PostTaskMutationFn = Apollo.MutationFunction<PostTaskMutation, PostTaskMutationVariables>;

/**
 * __usePostTaskMutation__
 *
 * To run a mutation, you first call `usePostTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postTaskMutation, { data, loading, error }] = usePostTaskMutation({
 *   variables: {
 *      caseRef: // value for 'caseRef'
 *      taskId: // value for 'taskId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePostTaskMutation(baseOptions?: Apollo.MutationHookOptions<PostTaskMutation, PostTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostTaskMutation, PostTaskMutationVariables>(PostTaskDocument, options);
      }
export type PostTaskMutationHookResult = ReturnType<typeof usePostTaskMutation>;
export type PostTaskMutationResult = Apollo.MutationResult<PostTaskMutation>;
export type PostTaskMutationOptions = Apollo.BaseMutationOptions<PostTaskMutation, PostTaskMutationVariables>;
export const PostTaskUploadDocument = gql`
    mutation postTaskUpload($caseRef: String, $taskId: String, $section: String, $input: FormData) {
  postTaskUpload(
    caseRef: $caseRef
    taskId: $taskId
    section: $section
    input: $input
  ) @rest(type: "File", path: "/api/v2/objections/{args.caseRef}/task/{args.taskId}/upload/{args.section}", method: "POST", bodySerializer: "fileEncode") {
    file
  }
}
    `;
export type PostTaskUploadMutationFn = Apollo.MutationFunction<PostTaskUploadMutation, PostTaskUploadMutationVariables>;

/**
 * __usePostTaskUploadMutation__
 *
 * To run a mutation, you first call `usePostTaskUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostTaskUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postTaskUploadMutation, { data, loading, error }] = usePostTaskUploadMutation({
 *   variables: {
 *      caseRef: // value for 'caseRef'
 *      taskId: // value for 'taskId'
 *      section: // value for 'section'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePostTaskUploadMutation(baseOptions?: Apollo.MutationHookOptions<PostTaskUploadMutation, PostTaskUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostTaskUploadMutation, PostTaskUploadMutationVariables>(PostTaskUploadDocument, options);
      }
export type PostTaskUploadMutationHookResult = ReturnType<typeof usePostTaskUploadMutation>;
export type PostTaskUploadMutationResult = Apollo.MutationResult<PostTaskUploadMutation>;
export type PostTaskUploadMutationOptions = Apollo.BaseMutationOptions<PostTaskUploadMutation, PostTaskUploadMutationVariables>;
export const BindCaseDocument = gql`
    query bindCase($caseRef: String) {
  bindCase(caseRef: $caseRef) @rest(path: "/api/v2/objections/{args.caseRef}/bind", method: "GET") {
    NoResponse
  }
}
    `;

/**
 * __useBindCaseQuery__
 *
 * To run a query within a React component, call `useBindCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useBindCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBindCaseQuery({
 *   variables: {
 *      caseRef: // value for 'caseRef'
 *   },
 * });
 */
export function useBindCaseQuery(baseOptions?: Apollo.QueryHookOptions<BindCaseQuery, BindCaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BindCaseQuery, BindCaseQueryVariables>(BindCaseDocument, options);
      }
export function useBindCaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BindCaseQuery, BindCaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BindCaseQuery, BindCaseQueryVariables>(BindCaseDocument, options);
        }
export type BindCaseQueryHookResult = ReturnType<typeof useBindCaseQuery>;
export type BindCaseLazyQueryHookResult = ReturnType<typeof useBindCaseLazyQuery>;
export type BindCaseQueryResult = Apollo.QueryResult<BindCaseQuery, BindCaseQueryVariables>;
export const CasesDocument = gql`
    query cases {
  cases @rest(type: "Cases", path: "/api/v2/objections/client/cases", method: "GET") {
    cases {
      caseRef
      advice
      assignedValuator {
        email
        firstName
        salutation
        surname
        phoneNumber
      }
      caseDocuments
      flow {
        flowSteps {
          flowStepStatus
          flowStepType
        }
        flowType
      }
      clientComments {
        sectionType
        text
        updatedAt
        uploads {
          fileType
          uuid
          fileName
        }
      }
      classification
      caseProperty {
        floorLevel
        bayWindowArea
        garageArea
        parkingArea
        wozDecisionDate
        structureArea
        atticArea
        kitchenAge
        heatingState
        heatingAge
        warmWater
        leadPipes
        solarPanels
        underfloorHeating
        floorInsulation
        roofInsulation
        wallInsulation
        doubleGlass
        leakage
        insidePaintwork
        outsidePaintwork
        windowFramesMaterial
        windowFramesRot
        insideCracks
        outsideCracks
        foundationSubsidence
        kitchenMaintenanceIndication
        bathroomAge
        bathroomMaintenanceIndication
        builtInKitchen
        bagId
        city
        outsideMaintenanceIndication
        insideMaintenanceIndication
        constructionYear
        houseNumber
        houseNumberAddition
        latitude
        livingArea
        locationIndication
        longitude
        luxuryIndication
        maintenanceIndication
        plotArea
        postcode
        propertyType
        purchaseMonth
        purchasePrice
        purchaseYear
        servicesIndication
        street
      }
      currentCaseStatus {
        expired
        final
        status
      }
      customerInputs {
        bathroomAge
        kitchenAge
        livingArea
        maintenanceIndication
        propertyType
        recentlySold
        relationshipToProperty
        sustainabilityIndication
        renovated
        userFlow
        wozValue
      }
      municipality
      objectionGoal
      recentlySold
      statusHistory {
        caseId
        status
        updatedAt
      }
      tasks {
        taskId
        uploads
        data {
          paymentRequestId
          objectionOutcome
          document {
            path
            id
            type
            createdAt
            fileData
            fileName
            fileType
          }
          livingArea
          plotArea
          annexes {
            id
            name
            value
            amount
            unit
            quasi
            index
          }
          clientComment {
            text
            uploads {
              fileData
              fileName
              fileType
              id
            }
          }
        }
        deadline
        statusHistory {
          caseId
          status
          updatedAt
        }
        status
        type
      }
      taxYear
      userFlow
      partnerUrl
      wozData {
        objectionWoz
        ewozValue
        savings {
          status
          min
          max
          avg
          waterTax {
            avg
            max
            min
          }
          incomeTax {
            avg
            max
            min
          }
          realEstateTax {
            avg
            max
            min
          }
        }
        wozValue
        finalWoz
        wozDecisionDate
        finalSavings {
          status
          min
          max
          avg
          waterTax {
            avg
            max
            min
          }
          incomeTax {
            avg
            max
            min
          }
          realEstateTax {
            avg
            max
            min
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCasesQuery__
 *
 * To run a query within a React component, call `useCasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCasesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCasesQuery(baseOptions?: Apollo.QueryHookOptions<CasesQuery, CasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CasesQuery, CasesQueryVariables>(CasesDocument, options);
      }
export function useCasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CasesQuery, CasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CasesQuery, CasesQueryVariables>(CasesDocument, options);
        }
export type CasesQueryHookResult = ReturnType<typeof useCasesQuery>;
export type CasesLazyQueryHookResult = ReturnType<typeof useCasesLazyQuery>;
export type CasesQueryResult = Apollo.QueryResult<CasesQuery, CasesQueryVariables>;
export const ChangeCaseDetailsDocument = gql`
    query changeCaseDetails($caseRef: String, $input: CasePropertyInput) {
  changeCaseDetails(caseRef: $caseRef, input: $input) @rest(type: "CaseProperty", path: "/api/v2/objections/client/cases/{args.caseRef}", method: "POST", bodySerializer: "kebabizeObject") {
    landOwnership
    floorInsulation
    landLeaseFee
    builtInKitchen
    bagId
    city
    renovated
    windowFramesRot
    roofInsulation
    efficiencyIndication
    warmWater
    floorLevel
    kitchenMaintenanceIndication
    bathroomMaintenanceIndication
    renovationCosts
    foundationSubsidence
    outsideMaintenanceIndication
    insideMaintenanceIndication
    heatingState
    kitchenAge
    renovationComplete
    leadPipes
    leakage
    wallInsulation
    solarPanels
    underfloorHeating
    outsideCracks
    appearanceIndication
    constructionYear
    houseNumber
    insideCracks
    doubleGlass
    insidePaintwork
    latitude
    livingArea
    locationIndication
    longitude
    windowFramesMaterial
    outsidePaintwork
    luxuryIndication
    maintenanceIndication
    plotArea
    postcode
    propertyType
    purchaseMonth
    purchasePrice
    purchaseYear
    servicesIndication
    street
    heatingAge
    bathroomAge
  }
}
    `;

/**
 * __useChangeCaseDetailsQuery__
 *
 * To run a query within a React component, call `useChangeCaseDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChangeCaseDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChangeCaseDetailsQuery({
 *   variables: {
 *      caseRef: // value for 'caseRef'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeCaseDetailsQuery(baseOptions?: Apollo.QueryHookOptions<ChangeCaseDetailsQuery, ChangeCaseDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChangeCaseDetailsQuery, ChangeCaseDetailsQueryVariables>(ChangeCaseDetailsDocument, options);
      }
export function useChangeCaseDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChangeCaseDetailsQuery, ChangeCaseDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChangeCaseDetailsQuery, ChangeCaseDetailsQueryVariables>(ChangeCaseDetailsDocument, options);
        }
export type ChangeCaseDetailsQueryHookResult = ReturnType<typeof useChangeCaseDetailsQuery>;
export type ChangeCaseDetailsLazyQueryHookResult = ReturnType<typeof useChangeCaseDetailsLazyQuery>;
export type ChangeCaseDetailsQueryResult = Apollo.QueryResult<ChangeCaseDetailsQuery, ChangeCaseDetailsQueryVariables>;
export const ChangeDetailsDocument = gql`
    query changeDetails($input: ChangeDetailsInput!) {
  changeDetails(input: $input) @rest(type: "User", path: "/api/v2/profile", method: "POST", bodySerializer: "kebabizeObject") {
    surname
    email
    salutation
    firstName
    surname
    phoneNumber
    dateOfBirth
    emailPreferences {
      wozAdvice
      wozNews
      otherMarketing
    }
  }
}
    `;

/**
 * __useChangeDetailsQuery__
 *
 * To run a query within a React component, call `useChangeDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChangeDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChangeDetailsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeDetailsQuery(baseOptions: Apollo.QueryHookOptions<ChangeDetailsQuery, ChangeDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChangeDetailsQuery, ChangeDetailsQueryVariables>(ChangeDetailsDocument, options);
      }
export function useChangeDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChangeDetailsQuery, ChangeDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChangeDetailsQuery, ChangeDetailsQueryVariables>(ChangeDetailsDocument, options);
        }
export type ChangeDetailsQueryHookResult = ReturnType<typeof useChangeDetailsQuery>;
export type ChangeDetailsLazyQueryHookResult = ReturnType<typeof useChangeDetailsLazyQuery>;
export type ChangeDetailsQueryResult = Apollo.QueryResult<ChangeDetailsQuery, ChangeDetailsQueryVariables>;
export const ChangeEmailDocument = gql`
    query changeEmail($input: ChangeEmailInput!) {
  changeEmail(input: $input) @rest(type: "User", path: "/api/v2/profile/credentials", method: "POST", bodySerializer: "kebabizeObject") {
    profile {
      surname
      email
      salutation
      firstName
      surname
      phoneNumber
    }
  }
}
    `;

/**
 * __useChangeEmailQuery__
 *
 * To run a query within a React component, call `useChangeEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useChangeEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChangeEmailQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeEmailQuery(baseOptions: Apollo.QueryHookOptions<ChangeEmailQuery, ChangeEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChangeEmailQuery, ChangeEmailQueryVariables>(ChangeEmailDocument, options);
      }
export function useChangeEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChangeEmailQuery, ChangeEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChangeEmailQuery, ChangeEmailQueryVariables>(ChangeEmailDocument, options);
        }
export type ChangeEmailQueryHookResult = ReturnType<typeof useChangeEmailQuery>;
export type ChangeEmailLazyQueryHookResult = ReturnType<typeof useChangeEmailLazyQuery>;
export type ChangeEmailQueryResult = Apollo.QueryResult<ChangeEmailQuery, ChangeEmailQueryVariables>;
export const ChangePasswordDocument = gql`
    query changePassword($input: ChangePasswordInput!) {
  changePassword(input: $input) @rest(type: "User", path: "/api/v2/profile/credentials", method: "POST", bodySerializer: "kebabizeObject") {
    NoResponse
  }
}
    `;

/**
 * __useChangePasswordQuery__
 *
 * To run a query within a React component, call `useChangePasswordQuery` and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChangePasswordQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangePasswordQuery(baseOptions: Apollo.QueryHookOptions<ChangePasswordQuery, ChangePasswordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChangePasswordQuery, ChangePasswordQueryVariables>(ChangePasswordDocument, options);
      }
export function useChangePasswordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChangePasswordQuery, ChangePasswordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChangePasswordQuery, ChangePasswordQueryVariables>(ChangePasswordDocument, options);
        }
export type ChangePasswordQueryHookResult = ReturnType<typeof useChangePasswordQuery>;
export type ChangePasswordLazyQueryHookResult = ReturnType<typeof useChangePasswordLazyQuery>;
export type ChangePasswordQueryResult = Apollo.QueryResult<ChangePasswordQuery, ChangePasswordQueryVariables>;
export const DeleteTaskUploadDocument = gql`
    query deleteTaskUpload($caseRef: String, $taskId: String, $documentId: String) {
  deleteTaskUpload(caseRef: $caseRef, taskId: $taskId, documentId: $documentId) @rest(path: "/api/v2/objections/{args.caseRef}/task/{args.taskId}/{args.documentId}", method: "DELETE") {
    NoResponse
  }
}
    `;

/**
 * __useDeleteTaskUploadQuery__
 *
 * To run a query within a React component, call `useDeleteTaskUploadQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaskUploadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeleteTaskUploadQuery({
 *   variables: {
 *      caseRef: // value for 'caseRef'
 *      taskId: // value for 'taskId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useDeleteTaskUploadQuery(baseOptions?: Apollo.QueryHookOptions<DeleteTaskUploadQuery, DeleteTaskUploadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeleteTaskUploadQuery, DeleteTaskUploadQueryVariables>(DeleteTaskUploadDocument, options);
      }
export function useDeleteTaskUploadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeleteTaskUploadQuery, DeleteTaskUploadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeleteTaskUploadQuery, DeleteTaskUploadQueryVariables>(DeleteTaskUploadDocument, options);
        }
export type DeleteTaskUploadQueryHookResult = ReturnType<typeof useDeleteTaskUploadQuery>;
export type DeleteTaskUploadLazyQueryHookResult = ReturnType<typeof useDeleteTaskUploadLazyQuery>;
export type DeleteTaskUploadQueryResult = Apollo.QueryResult<DeleteTaskUploadQuery, DeleteTaskUploadQueryVariables>;
export const DownloadDocumentDocument = gql`
    query downloadDocument($caseRef: String, $query: String) {
  downloadDocument(caseRef: $caseRef, query: $query) @rest(type: "Upload", path: "/api/v2/objections/{args.caseRef}/download{args.query}", method: "GET") {
    fileName
    fileType
    fileData
  }
}
    `;

/**
 * __useDownloadDocumentQuery__
 *
 * To run a query within a React component, call `useDownloadDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadDocumentQuery({
 *   variables: {
 *      caseRef: // value for 'caseRef'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useDownloadDocumentQuery(baseOptions?: Apollo.QueryHookOptions<DownloadDocumentQuery, DownloadDocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadDocumentQuery, DownloadDocumentQueryVariables>(DownloadDocumentDocument, options);
      }
export function useDownloadDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadDocumentQuery, DownloadDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadDocumentQuery, DownloadDocumentQueryVariables>(DownloadDocumentDocument, options);
        }
export type DownloadDocumentQueryHookResult = ReturnType<typeof useDownloadDocumentQuery>;
export type DownloadDocumentLazyQueryHookResult = ReturnType<typeof useDownloadDocumentLazyQuery>;
export type DownloadDocumentQueryResult = Apollo.QueryResult<DownloadDocumentQuery, DownloadDocumentQueryVariables>;
export const ForgotPasswordDocument = gql`
    query forgotPassword($input: ForgotPasswordInput!) {
  forgotPassword(input: $input) @rest(path: "/api/v2/reset-password/send-link", method: "POST") {
    NoResponse
  }
}
    `;

/**
 * __useForgotPasswordQuery__
 *
 * To run a query within a React component, call `useForgotPasswordQuery` and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useForgotPasswordQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useForgotPasswordQuery(baseOptions: Apollo.QueryHookOptions<ForgotPasswordQuery, ForgotPasswordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ForgotPasswordQuery, ForgotPasswordQueryVariables>(ForgotPasswordDocument, options);
      }
export function useForgotPasswordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ForgotPasswordQuery, ForgotPasswordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ForgotPasswordQuery, ForgotPasswordQueryVariables>(ForgotPasswordDocument, options);
        }
export type ForgotPasswordQueryHookResult = ReturnType<typeof useForgotPasswordQuery>;
export type ForgotPasswordLazyQueryHookResult = ReturnType<typeof useForgotPasswordLazyQuery>;
export type ForgotPasswordQueryResult = Apollo.QueryResult<ForgotPasswordQuery, ForgotPasswordQueryVariables>;
export const GetUserDataDocument = gql`
    query getUserData {
  getUserData @rest(type: "Profile", path: "/api/v2/profile", method: "GET") {
    email
    firstName
    salutation
    surname
    phoneNumber
    dateOfBirth
    emailPreferences {
      wozAdvice
      wozNews
      otherMarketing
    }
  }
}
    `;

/**
 * __useGetUserDataQuery__
 *
 * To run a query within a React component, call `useGetUserDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserDataQuery(baseOptions?: Apollo.QueryHookOptions<GetUserDataQuery, GetUserDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserDataQuery, GetUserDataQueryVariables>(GetUserDataDocument, options);
      }
export function useGetUserDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserDataQuery, GetUserDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserDataQuery, GetUserDataQueryVariables>(GetUserDataDocument, options);
        }
export type GetUserDataQueryHookResult = ReturnType<typeof useGetUserDataQuery>;
export type GetUserDataLazyQueryHookResult = ReturnType<typeof useGetUserDataLazyQuery>;
export type GetUserDataQueryResult = Apollo.QueryResult<GetUserDataQuery, GetUserDataQueryVariables>;
export const LoginDocument = gql`
    query login($input: LoginInput!) {
  login(input: $input) @rest(type: "User", path: "/api/v2/login", method: "POST") {
    idToken
    profile {
      surname
      email
      salutation
      firstName
      surname
      phoneNumber
    }
  }
}
    `;

/**
 * __useLoginQuery__
 *
 * To run a query within a React component, call `useLoginQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoginQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginQuery(baseOptions: Apollo.QueryHookOptions<LoginQuery, LoginQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoginQuery, LoginQueryVariables>(LoginDocument, options);
      }
export function useLoginLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoginQuery, LoginQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoginQuery, LoginQueryVariables>(LoginDocument, options);
        }
export type LoginQueryHookResult = ReturnType<typeof useLoginQuery>;
export type LoginLazyQueryHookResult = ReturnType<typeof useLoginLazyQuery>;
export type LoginQueryResult = Apollo.QueryResult<LoginQuery, LoginQueryVariables>;
export const SocialLoginDocument = gql`
    query socialLogin($input: SocialLoginInput!) {
  socialLogin(input: $input) @rest(type: "User", path: "/api/v2/login", method: "POST") {
    idToken
    profile {
      surname
      email
      salutation
      firstName
      surname
      phoneNumber
    }
  }
}
    `;

/**
 * __useSocialLoginQuery__
 *
 * To run a query within a React component, call `useSocialLoginQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialLoginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialLoginQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSocialLoginQuery(baseOptions: Apollo.QueryHookOptions<SocialLoginQuery, SocialLoginQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SocialLoginQuery, SocialLoginQueryVariables>(SocialLoginDocument, options);
      }
export function useSocialLoginLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SocialLoginQuery, SocialLoginQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SocialLoginQuery, SocialLoginQueryVariables>(SocialLoginDocument, options);
        }
export type SocialLoginQueryHookResult = ReturnType<typeof useSocialLoginQuery>;
export type SocialLoginLazyQueryHookResult = ReturnType<typeof useSocialLoginLazyQuery>;
export type SocialLoginQueryResult = Apollo.QueryResult<SocialLoginQuery, SocialLoginQueryVariables>;
export const EmailTokenLoginDocument = gql`
    query emailTokenLogin($input: EmailTokenLoginInput!) {
  emailTokenLogin(input: $input) @rest(type: "User", path: "/api/v2/login", method: "POST", bodySerializer: "kebabizeObject") {
    idToken
    profile {
      surname
      email
      salutation
      firstName
      surname
      phoneNumber
    }
  }
}
    `;

/**
 * __useEmailTokenLoginQuery__
 *
 * To run a query within a React component, call `useEmailTokenLoginQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailTokenLoginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailTokenLoginQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEmailTokenLoginQuery(baseOptions: Apollo.QueryHookOptions<EmailTokenLoginQuery, EmailTokenLoginQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailTokenLoginQuery, EmailTokenLoginQueryVariables>(EmailTokenLoginDocument, options);
      }
export function useEmailTokenLoginLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailTokenLoginQuery, EmailTokenLoginQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailTokenLoginQuery, EmailTokenLoginQueryVariables>(EmailTokenLoginDocument, options);
        }
export type EmailTokenLoginQueryHookResult = ReturnType<typeof useEmailTokenLoginQuery>;
export type EmailTokenLoginLazyQueryHookResult = ReturnType<typeof useEmailTokenLoginLazyQuery>;
export type EmailTokenLoginQueryResult = Apollo.QueryResult<EmailTokenLoginQuery, EmailTokenLoginQueryVariables>;
export const LoginAvailableDocument = gql`
    query loginAvailable($input: LoginAvailableInput!) {
  loginAvailable(input: $input) @rest(type: "LoginAvailable", path: "/api/v2/login-available", method: "POST") {
    loginAvailable
  }
}
    `;

/**
 * __useLoginAvailableQuery__
 *
 * To run a query within a React component, call `useLoginAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoginAvailableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoginAvailableQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginAvailableQuery(baseOptions: Apollo.QueryHookOptions<LoginAvailableQuery, LoginAvailableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoginAvailableQuery, LoginAvailableQueryVariables>(LoginAvailableDocument, options);
      }
export function useLoginAvailableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoginAvailableQuery, LoginAvailableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoginAvailableQuery, LoginAvailableQueryVariables>(LoginAvailableDocument, options);
        }
export type LoginAvailableQueryHookResult = ReturnType<typeof useLoginAvailableQuery>;
export type LoginAvailableLazyQueryHookResult = ReturnType<typeof useLoginAvailableLazyQuery>;
export type LoginAvailableQueryResult = Apollo.QueryResult<LoginAvailableQuery, LoginAvailableQueryVariables>;
export const MessageValuatorDocument = gql`
    query messageValuator($caseRef: String, $input: MessageValuatorInput!) {
  messageValuator(caseRef: $caseRef, input: $input) @rest(path: "/api/v2/objections/{args.caseRef}/message-valuator", method: "POST") {
    NoResponse
  }
}
    `;

/**
 * __useMessageValuatorQuery__
 *
 * To run a query within a React component, call `useMessageValuatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageValuatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageValuatorQuery({
 *   variables: {
 *      caseRef: // value for 'caseRef'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMessageValuatorQuery(baseOptions: Apollo.QueryHookOptions<MessageValuatorQuery, MessageValuatorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessageValuatorQuery, MessageValuatorQueryVariables>(MessageValuatorDocument, options);
      }
export function useMessageValuatorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessageValuatorQuery, MessageValuatorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessageValuatorQuery, MessageValuatorQueryVariables>(MessageValuatorDocument, options);
        }
export type MessageValuatorQueryHookResult = ReturnType<typeof useMessageValuatorQuery>;
export type MessageValuatorLazyQueryHookResult = ReturnType<typeof useMessageValuatorLazyQuery>;
export type MessageValuatorQueryResult = Apollo.QueryResult<MessageValuatorQuery, MessageValuatorQueryVariables>;
export const PostCaseDocument = gql`
    query postCase($caseRef: String, $input: PostCaseInput!) {
  postCase(caseRef: $caseRef, input: $input) @rest(type: "Case", path: "/api/v2/objections/{args.caseRef}/woz-check", method: "POST", bodySerializer: "kebabizeObject") {
    caseProperty {
      landOwnership
    }
  }
}
    `;

/**
 * __usePostCaseQuery__
 *
 * To run a query within a React component, call `usePostCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostCaseQuery({
 *   variables: {
 *      caseRef: // value for 'caseRef'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePostCaseQuery(baseOptions: Apollo.QueryHookOptions<PostCaseQuery, PostCaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostCaseQuery, PostCaseQueryVariables>(PostCaseDocument, options);
      }
export function usePostCaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostCaseQuery, PostCaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostCaseQuery, PostCaseQueryVariables>(PostCaseDocument, options);
        }
export type PostCaseQueryHookResult = ReturnType<typeof usePostCaseQuery>;
export type PostCaseLazyQueryHookResult = ReturnType<typeof usePostCaseLazyQuery>;
export type PostCaseQueryResult = Apollo.QueryResult<PostCaseQuery, PostCaseQueryVariables>;
export const RegisterDocument = gql`
    query register($input: RegisterInput!) {
  register(input: $input) @rest(type: "User", path: "/api/v2/signup", method: "POST") {
    idToken
    profile {
      surname
      email
      salutation
      firstName
      surname
      phoneNumber
    }
  }
}
    `;

/**
 * __useRegisterQuery__
 *
 * To run a query within a React component, call `useRegisterQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegisterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegisterQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterQuery(baseOptions: Apollo.QueryHookOptions<RegisterQuery, RegisterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegisterQuery, RegisterQueryVariables>(RegisterDocument, options);
      }
export function useRegisterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegisterQuery, RegisterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegisterQuery, RegisterQueryVariables>(RegisterDocument, options);
        }
export type RegisterQueryHookResult = ReturnType<typeof useRegisterQuery>;
export type RegisterLazyQueryHookResult = ReturnType<typeof useRegisterLazyQuery>;
export type RegisterQueryResult = Apollo.QueryResult<RegisterQuery, RegisterQueryVariables>;
export const ResetPasswordDocument = gql`
    query resetPassword($input: ResetPasswordInput!) {
  resetPassword(input: $input) @rest(path: "/api/v2/reset-password", method: "POST") {
    idToken
    profile {
      surname
      email
      salutation
      firstName
      surname
      phoneNumber
    }
  }
}
    `;

/**
 * __useResetPasswordQuery__
 *
 * To run a query within a React component, call `useResetPasswordQuery` and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResetPasswordQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordQuery(baseOptions: Apollo.QueryHookOptions<ResetPasswordQuery, ResetPasswordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResetPasswordQuery, ResetPasswordQueryVariables>(ResetPasswordDocument, options);
      }
export function useResetPasswordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResetPasswordQuery, ResetPasswordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResetPasswordQuery, ResetPasswordQueryVariables>(ResetPasswordDocument, options);
        }
export type ResetPasswordQueryHookResult = ReturnType<typeof useResetPasswordQuery>;
export type ResetPasswordLazyQueryHookResult = ReturnType<typeof useResetPasswordLazyQuery>;
export type ResetPasswordQueryResult = Apollo.QueryResult<ResetPasswordQuery, ResetPasswordQueryVariables>;
export const SubmitPoaDocument = gql`
    query submitPoa($caseRef: String, $input: SubmitPoaInput) {
  submitPoa(caseRef: $caseRef, input: $input) @rest(path: "/api/v2/objections/{args.caseRef}/proceed", method: "POST", bodySerializer: "kebabizeObject") {
    NoResponse
  }
}
    `;

/**
 * __useSubmitPoaQuery__
 *
 * To run a query within a React component, call `useSubmitPoaQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubmitPoaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubmitPoaQuery({
 *   variables: {
 *      caseRef: // value for 'caseRef'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitPoaQuery(baseOptions?: Apollo.QueryHookOptions<SubmitPoaQuery, SubmitPoaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubmitPoaQuery, SubmitPoaQueryVariables>(SubmitPoaDocument, options);
      }
export function useSubmitPoaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubmitPoaQuery, SubmitPoaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubmitPoaQuery, SubmitPoaQueryVariables>(SubmitPoaDocument, options);
        }
export type SubmitPoaQueryHookResult = ReturnType<typeof useSubmitPoaQuery>;
export type SubmitPoaLazyQueryHookResult = ReturnType<typeof useSubmitPoaLazyQuery>;
export type SubmitPoaQueryResult = Apollo.QueryResult<SubmitPoaQuery, SubmitPoaQueryVariables>;
export const SubmitPoaOrangeCaseDocument = gql`
    query submitPoaOrangeCase($caseRef: String, $input: SubmitPoaInput) {
  submitPoaOrangeCase(caseRef: $caseRef, input: $input) @rest(path: "/api/v2/objections/{args.caseRef}/orange/persist", method: "POST", bodySerializer: "kebabizeObject") {
    NoResponse
  }
}
    `;

/**
 * __useSubmitPoaOrangeCaseQuery__
 *
 * To run a query within a React component, call `useSubmitPoaOrangeCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubmitPoaOrangeCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubmitPoaOrangeCaseQuery({
 *   variables: {
 *      caseRef: // value for 'caseRef'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitPoaOrangeCaseQuery(baseOptions?: Apollo.QueryHookOptions<SubmitPoaOrangeCaseQuery, SubmitPoaOrangeCaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubmitPoaOrangeCaseQuery, SubmitPoaOrangeCaseQueryVariables>(SubmitPoaOrangeCaseDocument, options);
      }
export function useSubmitPoaOrangeCaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubmitPoaOrangeCaseQuery, SubmitPoaOrangeCaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubmitPoaOrangeCaseQuery, SubmitPoaOrangeCaseQueryVariables>(SubmitPoaOrangeCaseDocument, options);
        }
export type SubmitPoaOrangeCaseQueryHookResult = ReturnType<typeof useSubmitPoaOrangeCaseQuery>;
export type SubmitPoaOrangeCaseLazyQueryHookResult = ReturnType<typeof useSubmitPoaOrangeCaseLazyQuery>;
export type SubmitPoaOrangeCaseQueryResult = Apollo.QueryResult<SubmitPoaOrangeCaseQuery, SubmitPoaOrangeCaseQueryVariables>;